import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";

import { Switch } from "react-router-dom";
import { Permissions } from "../../../util/Permissions";
import { MaintenanceFeeManagement } from "./MaintenanceFee";

const MaintenanceFeeManagementPages = () => {
    return <>
        <AsideMenu>
            <UserGroupMenu destination="/maintenance" />
        </AsideMenu>
        <Section>
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    <ContentRoute path="/maintenance/:userGroup" permission={Permissions.MAINTENANCE_FEE} component={MaintenanceFeeManagement} />
                </Switch>
            </Suspense>
        </Section>
    </>
};

export default MaintenanceFeeManagementPages;
